import React from 'react'

export default class NoDataComponent extends React.Component {
  render () {
    return (
      <div className='no-data-container'>
        <span className='no-data-text'>No se encontraron Tipos de Afiliación</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Type/SearchType/NotDataAvailable.js